import {
  IButton,
  IButtonFields,
  IContextualButton,
} from '../../../types/@types/generated/contentful';
import getLinkHref from './getLinkHref';

function isIButton(button?: IButton | IContextualButton): button is IButton {
  return button?.sys.contentType.sys.id === 'button';
}

const buttonToCompatibleProps = ({
  button,
  settings,
}: {
  button?: IButton | IContextualButton;
  settings?: Record<string, unknown>;
}) => {
  if (isIButton(button)) {
    button = button as IButton;
    return {
      label: button?.fields.label,
      prompt: button?.fields.prompt,
      href: getLinkHref(button?.fields.link) || button?.fields.href,
      size: button?.fields.size,
      trailingIconName: button?.fields.trailingIconName,
      leadingIconName: button?.fields?.leadingIconName,
      colorContext: button?.fields.colorContext,
      variant: button?.fields.variant,
    };
  } else {
    return {
      label: (settings?.CTAText || settings?.buttonLabel || button?.fields.label) as
        | string
        | undefined,
      prompt: settings?.CTAPrompt as string | undefined,
      href: settings?.href as string | undefined,
      colorContext: (settings?.buttonColor || settings?.CTAColor) as
        | IButtonFields['colorContext']
        | undefined,
      size: (settings?.buttonLarge || 'large') as IButtonFields['size'] | undefined,
    };
  }
};

export default buttonToCompatibleProps;
